import axios from "axios";
import { Toast } from "../../util/Toast";

import {
  GET_REPORTED_REELS,
  DISMISS_REEL_REPORT,
  DELETE_REPORTED_REEL,
} from "./types";

export const getReportedReels = () => (dispatch) => {
  axios
    .get("/postReport/reels")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_REPORTED_REELS, payload: res.data.report });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const deleteReportedReel = (postId, postType) => (dispatch) =>
  axios
    .post("/postReport/action?action=delete", { postId, postType })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }

      dispatch({ type: DELETE_REPORTED_REEL, payload: { postId } });
      return true;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return false;
    });

export const dismissReelReport = (postId, postType) => (dispatch) =>
  axios
    .post("/postReport/dismiss", { postId, postType })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }

      dispatch({ type: DISMISS_REEL_REPORT, payload: { postId } });
      return true;
    })
    .catch((error) => {
      Toast("error", error.message);
      return false;
    });
